import { isEqual } from 'lodash'
import { TrailWay } from '../models/TrailWay.model'
import { TrailRelation } from '../models/TrailRelation.model'

const isBlank = (id?: string | number | null): boolean => !id || id.toString().trim() === ''

// Drop the empty rows the form's "add" buttons create until the admin fills them in.
export const nonBlankWays = (ways?: TrailWay[]): TrailWay[] => (ways ?? []).filter((way) => !isBlank(way.wayId))

export const nonBlankOsmRelations = (relations?: TrailRelation[]): TrailRelation[] =>
  (relations ?? []).filter((relation) => !isBlank(relation.relationId))

/**
 * Compare the form's way rows against the saved ones. Both sides are reduced to
 * non-blank string ids so a numeric id from the API equals the same id typed in
 * the form, and an unfilled row isn't treated as a change.
 */
export const didWaysChange = (next?: TrailWay[], prev?: TrailWay[]): boolean =>
  !isEqual(
    nonBlankWays(next).map((way) => ({ wayId: String(way.wayId) })),
    nonBlankWays(prev).map((way) => ({ wayId: String(way.wayId) })),
  )

export const didOsmRelationsChange = (next?: TrailRelation[], prev?: TrailRelation[]): boolean =>
  !isEqual(
    nonBlankOsmRelations(next).map((relation) => ({ relationId: String(relation.relationId) })),
    nonBlankOsmRelations(prev).map((relation) => ({ relationId: String(relation.relationId) })),
  )
